{
  "apexEnableQuadraticProgrammingFormulationMoveMode": false,
  "apexExplicitConfigSet": "",
  "apexFeatureImportances": false,
  "apexMaxCandidateGenerationTimeSeconds": 0,
  "apexNumCandidates": 0,
  "apexNumCandidatesToScanPerChildWorkflow": 0,
  "apexNumChildWorkflows": 0,
  "apexTargetIngredientDiversityCount": 0,
  "defaultDSIntermediates": false,
  "enableApex": false,
  "enableCatalystAgent": false,
  "enableCatalystAgentDebug": false,
  "enableAsyncDefaultPredictor": false,
  "enableCandidateViewOptions": false,
  "enableCandidateToMaterial": false,
  "enableCombinedLabelsIngredientsTabs": false,
  "enableCreateRawMaterial": false,
  "enableCreateRawMaterialFromPDF": false,
  "enableDataDog": true,
  "enableFeatureImpactPlots": false,
  "enableSearchSpaceConstraintsFromTrainingData": false,
  "enableSearchSpaceCopyReconcileModal": false,
  "enableFeatureCustomization": false,
  "enableFullStory": false,
  "enableHelpScout": true,
  "enableIngestTemplateDataset": false,
  "enableInsightsCopilotDemo": false,
  "enableMaterialsV3": false,
  "enableModelAssistant": true,
  "enableFastSearchSpaceValidation": false,
  "enableModelExplorerFlatFormulation": false,
  "enablePredictionInsights": false,
  "enablePrivateDocuments": false,
  "enableProductionHSBeacon": false,
  "enableSentry": true,
  "enableSlProgressBranchSummary": false,
  "enableSnapshotsAsDataSources": false,
  "enableSupportChat": false,
  "enableZendesk": false,
  "enforceDataManagerDataset": false,
  "maxFormulationDesignIngredients": 128,
  "maxFormulationNonzeroIngredients": 32,
  "maxMaterialsPaginationPageSize": 500,
  "maxMLModelOutputs": 32,
  "maxTerminalMaterialsInAnalysisWorkflowQuery": 5000,
  "predictorEvaluationResultDownsamplingLimit": 10000,
  "plotsPerAnalysisWorkflow": 10,
  "showSearchListCreation": false,
  "useTestApexConfig": false,
  "trialTermsUrl": ""
}
